import React, {useEffect, useState} from "react";
import Column from "@amzn/meridian/column";
import {injectIntl} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select";
import PropTypes from "prop-types";

const SearchableSelectModal = (props) => {

    const {formatMessage} = props.intl;
    const {preSelectedValue, error, setError, selectedValue, setSelectedValue, options, htmlId,
    placeholderValue, placeholderDefaultValue} = props;

    const [searchText, setSearchText] = useState(preSelectedValue || '')
    const [filteredOptions, setFilteredOptions] = useState([...options] || [])

    const handleSelectChange = (value) => {
        setSearchText(value);
        setSelectedValue(value);
        setError(false);
    };

    useEffect(() => {
        if (searchText === '') {
            setFilteredOptions(options)
        } else if (searchText === preSelectedValue) {
            setFilteredOptions(options)
            setSelectedValue(preSelectedValue)
            setError(false)
        } else {
            const filteredValues = options.filter((type) =>
                type.includes(searchText)
            );
            setFilteredOptions(filteredValues);
        }
    }, [searchText, options]);

    const generateDropDown = () => {
        return (
            filteredOptions.map((value) => (
                <SelectOption
                    key={value}
                    value={value}
                    label={value} />
            ))
        )
    }

    const handleBlur = () => {
        if ((searchText === '') || (searchText && !selectedValue)){
            setError(true);
        } else {
            setError(false);
        }
    };

    return (
        <Column>
            <Select id={htmlId}
                   value={selectedValue || searchText}
                   onChange={handleSelectChange}
                   placeholder= {(placeholderValue && placeholderDefaultValue) ?
                           formatMessage({ id: placeholderValue, defaultMessage: placeholderDefaultValue }) : ""
                   }
                   onBlur={handleBlur}
                   onSearch={setSearchText}
                   searchQuery={searchText}
                   error={error}
            >
            {
                filteredOptions.length > 0 && generateDropDown()
            }
            </Select>
        </Column>
    )
}

SearchableSelectModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    preSelectedValue: PropTypes.string,
    error: PropTypes.bool.isRequired,
    setError: PropTypes.func.isRequired,
    selectedValue: PropTypes.string,
    setSelectedValue: PropTypes.func,
    options: PropTypes.array.isRequired,
    htmlId: PropTypes.string,
    placeholderValue: PropTypes.string.isRequired,
    placeholderDefaultValue: PropTypes.string.isRequired
};

export default injectIntl(SearchableSelectModal);


// WEBPACK FOOTER //
// ./src/components/commonui/SearchableSelectModal.js